// src/components/translations.js

const translations = {
  en: {
    nav: { about: 'About', solution: 'Solution', how: 'How It Works', ecosystem: 'Ecosystem' },
    hero: {
      subtitle: 'Precision-powered recovery. Augmented by wearable technology. Guided by intelligence.',
      discover: 'Discover How',
      getStarted: 'Get Started'
    },
    about: {
      title: 'The Metabolic Crisis',
      heading: 'The Path to Metabolic Breakdown',
      points: ['Obesity', 'Hypertension', 'Cardiovascular disease', 'Type 2 diabetes', 'Chronic inflammation', 'Neurodegeneration'],
      text: 'By the time conventional medicine reacts, irreversible damage may already be done. We start much earlier — quietly shifting the trajectory before it becomes visible.',
      text1: 'Metabolic dysfunction often begins silently — a cascade of biological drift from insulin sensitivity to full-blown disease.',
      map: ["Insulin Sensitive", "Insulin Resistant", "Pre-Diabetic", "Metabolic Syndrome"],
    },
    solution: {
      title: 'Our Approach',
      heading: 'Precision Reversal Begins Here',
      text: 'Metabolify leverages biosignal intelligence to recalibrate your body’s trajectory through:',
      features: [
        { icon: 'fa-utensils', title: 'Adaptive Nutrition Algorithms' },
        { icon: 'fa-capsules', title: 'Targeted Biochemical Support' },
        { icon: 'fa-chart-line', title: 'Wearable CGM Integration' },
        { icon: 'fa-dumbbell', title: 'Tailored Movement Protocols' }
      ]
    },
    how: {
      title: 'How It Works',
      steps: [
        ['Data Collection', 'We extract continuous biosignals through CGMs, dietary markers, and clinical metadata.'],
        ['AI Analysis', 'Our system processes thousands of unseen signals to uncover what your body won’t tell you directly.'],
        ['Expert Oversight', 'A hybrid model of clinical judgment and internal protocols ensures safe adaptation.'],
        ['Personalized Plan', 'What you see is just the surface. Beneath it lies continuous recalibration.']
      ]
    },
    ecosystem: {
      title: 'The Ecosystem',
      intro: 'Our curated network integrates trusted providers and partners to extend the Metabolify experience into the physical world.',
      items: [
        ['fa-apple-alt', 'Organic Food Providers', 'Clean, curated food from farms aligned with metabolic needs.'],
        ['fa-pills', 'High-Integrity Supplements', 'Scientifically vetted molecular formulations.'],
        ['fa-dumbbell', 'Partner Fitness Centers', 'Access to professionals trained in our protocols.'],
        ['fa-utensils', 'Smart Meal Services', 'Pre-configured meal plans designed for absorption efficiency.']
      ]
    },
    cta: {
      coming: 'Coming Soon',
      title: 'Begin Your Metabolic Reset Soon',
      text: 'Our metabolic health platform is currently under development. Check back soon for updates.',
      learn: 'Learn More'
    },
    rights: {
      reserved: 'All rights reserved'
    }
  },
  tr: {
    nav: { about: 'Hakkında', solution: 'Çözüm', how: 'Nasıl Çalışır', ecosystem: 'Ekosistem' },
    hero: {
      subtitle: 'Giyilebilir teknolojiyle desteklenen hassasiyete dayalı iyileşme. Zekayla yönlendirilen sağlık.',
      discover: 'Nasıl Çalıştığını Keşfet',
      getStarted: 'Başla'
    },
    about: {
      title: 'Metabolik Kriz',
      heading: 'Metabolik Bozulmanın Yolu',
      points: ['Obezite', 'Hipertansiyon', 'Kalp hastalığı', 'Tip 2 diyabet', 'Kronik inflamasyon', 'Nörodejenerasyon'],
      text: 'Geleneksel tıp tepki verdiğinde, geri dönüşü olmayan hasarlar çoktan oluşmuş olabilir. Biz çok daha önce başlıyoruz — görünmeden önce yönü sessizce değiştiriyoruz.',
      text1: 'Metabolik bozukluk genellikle sessizce başlar — insülin hassasiyetinden tam gelişmiş hastalığa biyolojik bir kaymanın zincirlemesi.',
      map: ["İnsülin Duyarlı", "İnsülin Direnci", "Prediyabet", "Metabolik Sendrom"]
    },
    solution: {
      title: 'Yaklaşımımız',
      heading: 'Hassasiyete Dayalı Geri Dönüş Burada Başlar',
      text: 'Metabolify, vücudunuzun gidişatını yeniden kalibre etmek için biyo-sinyal zekasını kullanır.',
      features: [
        { icon: 'fa-utensils', title: 'Uyarlanabilir Beslenme Algoritmaları' },
        { icon: 'fa-capsules', title: 'Hedefe Yönelik Biyokimyasal Destek' },
        { icon: 'fa-chart-line', title: 'Giyilebilir CGM Entegrasyonu' },
        { icon: 'fa-dumbbell', title: 'Özelleştirilmiş Hareket Protokolleri' }
      ]
    },
    how: {
      title: 'Nasıl Çalışır',
      steps: [
        ['Veri Toplama', 'CGM, diyet göstergeleri ve klinik verilerle sürekli biyo-sinyaller toplarız.'],
        ['Yapay Zeka Analizi', 'Sistemimiz binlerce gizli sinyali işleyerek vücudunuzun doğrudan söylemediğini açığa çıkarır.'],
        ['Uzman Gözetimi', 'Klinik yargı ve iç protokollerden oluşan hibrit model güvenli adaptasyonu sağlar.'],
        ['Kişiselleştirilmiş Plan', 'Gördüğünüz sadece yüzey. Altında sürekli bir yeniden kalibrasyon vardır.']
      ]
    },
    ecosystem: {
      title: 'Ekosistem',
      intro: 'Seçkin iş ortaklarıyla entegre ağımız, Metabolify deneyimini fiziksel dünyaya taşır.',
      items: [
        ['fa-apple-alt', 'Organik Gıda Tedarikçileri', 'Metabolik ihtiyaçlara uygun çiftliklerden seçilmiş temiz gıdalar.'],
        ['fa-pills', 'Yüksek Bütünlüğe Sahip Takviyeler', 'Bilimsel olarak test edilmiş moleküler formülasyonlar.'],
        ['fa-dumbbell', 'Ortak Spor Merkezleri', 'Protokollerimizde eğitim almış profesyonellere erişim.'],
        ['fa-utensils', 'Akıllı Yemek Hizmetleri', 'Emilim verimliliği için önceden yapılandırılmış yemek planları.']
      ]
    },
    cta: {
      coming: 'Çok Yakında',
      title: 'Metabolik Sıfırlamanıza Yakında Başlayın',
      text: 'Metabolik sağlık platformumuz geliştirme aşamasındadır. Güncellemeler için tekrar kontrol edin.',
      learn: 'Daha Fazla Bilgi'
    },
    rights: {
      reserved: 'Tüm hakları saklıdır'
    }
  }
};

const detectBrowserLang = () => {
  const lang = navigator.language || navigator.userLanguage;
  return lang.startsWith('tr') ? 'tr' : 'en';
};

export default translations;
export { detectBrowserLang };
